import { ReactNode, useCallback, useRef } from 'react';

import {
  CurrentPageView,
  PageTrackingContext,
} from '../../contexts/PageTrackingContext';

export const PageTrackingProvider = ({ children }: { children: ReactNode }) => {
  const currentPageViewRef = useRef<CurrentPageView>({
    pageId: null,
    pageViewId: null,
  });
  const notifierRef = useRef<(() => void) | null>(null);

  const notifyPageTracked = useCallback(() => {
    notifierRef.current?.();
  }, []);

  const setNotifier = useCallback((fn: (() => void) | null) => {
    notifierRef.current = fn;
  }, []);

  return (
    <PageTrackingContext.Provider
      value={{ currentPageViewRef, notifyPageTracked, setNotifier }}
    >
      {children}
    </PageTrackingContext.Provider>
  );
};
